import React from 'react';
import { useFadeInOnScroll } from '../../hooks/useScrollEffects';
import './MentorSection.css';

const MentorSection = () => {
  const { elementRef: titleRef, isVisible: titleVisible, transformStyle: titleTransform } = useFadeInOnScroll('TITLE');
  const { elementRef: bioRef, isVisible: bioVisible, transformStyle: bioTransform } = useFadeInOnScroll('CONTENT');
  const { elementRef: imageRef, isVisible: imageVisible, transformStyle: imageTransform } = useFadeInOnScroll('IMAGE');

  return (
    <div className="mentor-section">
      <div className="mentor-background-charts">
        <div className="mentor-blur-effects">
          {Array.from({length: 12}, (_, i) => (
            <div key={i} className={`mentor-blur-ellipse ellipse-${i + 1}`}></div>
          ))}
        </div>
      </div>
      
      <div className="mentor-content">
        <div className="mentor-text">
          <h2 
            ref={titleRef}
            className={`section-title scroll-fade-in ${titleVisible ? 'visible' : ''}`}
            style={titleTransform}
          >
            Conheça seu mentor
          </h2>
          <div 
            ref={bioRef}
            className={`mentor-bio scroll-fade-in ${bioVisible ? 'visible' : ''}`}
            style={bioTransform}
          >
            <p className="mentor-quote">
              "Há quase uma década, vivo <strong>exclusivamente de trade</strong>, construindo minha liberdade financeira através de um mercado que, para muitos, ainda parece complexo e inacessível. Nesse caminho, me tornei <strong>fundador do 1º Hub de Traders do Nordeste</strong>, um espaço pioneiro que nasceu com a missão de unir pessoas comuns em torno de um único objetivo: aprender a investir e a operar de forma segura, prática e lucrativa.
            </p>
            <p className="mentor-quote">
              Sou também o criador da <strong>SBX Trade Academy</strong>, uma escola feita para quebrar barreiras, simplificar o que parece complicado e mostrar, de forma transparente, como qualquer pessoa pode começar a trilhar seu caminho no mercado financeiro. Acredito que o conhecimento certo, aplicado com disciplina e orientação, pode transformar realidades.
            </p>
            <p className="mentor-quote">
              Minha missão é <strong>democratizar o acesso ao mercado financeiro</strong> — sem segredos, sem fórmulas mágicas, sem promessas vazias. Quero provar que, com método e acompanhamento, é possível construir consistência, proteger seu patrimônio e alcançar resultados sólidos.
            </p>
            <p className="mentor-quote">
              Hoje, dedico minha vida a OPERAR e <strong>ensinar novos traders</strong>, compartilhando não apenas as estratégias que me permitiram chegar até aqui, mas também a mentalidade necessária para que cada um descubra sua própria forma de vencer no mercado.
            </p>
            <p className="mentor-quote">
              Se eu consegui viver exclusivamente de trade, <strong>qualquer pessoa, com os passos certos, pode conquistar também a liberdade de operar com segurança e ganhar dinheiro de forma real, dia após dia.</strong>"
            </p>
          </div>
        </div>
        
        <div 
          ref={imageRef}
          className={`mentor-image-container scroll-fade-in ${imageVisible ? 'visible' : ''}`}
          style={imageTransform}
        >
          <img 
            src="/images/mentor-image.png" 
            alt="Mentor - Especialista em Trading"
            className="mentor-image"
          />
        </div>
      </div>
      
      <div className="mentor-decorative-blur"></div>
    </div>
  );
};

export default MentorSection;
